// src/components/AuthCheck.jsx
import { useEffect, useState } from 'react';
import { API_CONFIG } from '../../Utils/APIConfig';
import UpgradeSubscription from "../../Modules/Settings/UpgradeSubscription/UpgradeSubscription";
import { isAfter } from 'date-fns';
import { getAgencyData } from '../../Utils/Storage';
import IndexPage from '../../Modules/Landing/IndexPage';

const AuthCheck = ({ children, redirectUrl = '/Web' }) => {
    const [authorized, setAuthorized] = useState(false);
    const [isUpgradeOpen, setIsUpgradeOpen] = useState(false);
    const [isPaymentInProgress, setIsPaymentInProgress] = useState(false);

    useEffect(() => {
        const jarvis = localStorage.getItem('Jarvis');
        if (!jarvis) {
            localStorage.clear();
            const targetUrl = redirectUrl || '/Web';
            const currentPath = window.location.pathname.toLowerCase().replace(/\/+$/, '');
            const targetPath = targetUrl.toLowerCase().replace(/\/+$/, '');
            if (currentPath !== targetPath) {
                window.location.replace(targetUrl);
            }
        } else {
            let agnData = getAgencyData();
            if (agnData) {
                let currDT = new Date();
                let subTillDT = agnData.SubTillDT ? new Date(agnData.SubTillDT) : null;
                let subTypeID = agnData?.SubTypeID;
                let isExpired = false;
                if (subTillDT !== null && isAfter(currDT, subTillDT) && subTypeID !== 1 && subTypeID !== 0) {
                    isExpired = true;
                }
                if (isExpired) {
                    setIsUpgradeOpen(true);
                }
            }
            setAuthorized(true);
        }
    }, [redirectUrl]);

    if (!authorized) {
        return <IndexPage />;
    }

    return (
        <>
            {children}

            {/* show upgrade modal when expired */}
            <UpgradeSubscription
                open={isUpgradeOpen && !isPaymentInProgress}
                onClose={() => { }}
                hideCloseButton={true}
                onPaymentStart={() => setIsPaymentInProgress(true)}
                onPaymentCancel={() => {
                    setIsPaymentInProgress(false);
                    setIsUpgradeOpen(true);
                }}
                onPaymentSuccess={() => setIsPaymentInProgress(false)}
            />
        </>
    );
};

export default AuthCheck;